import React from 'react';
import skills from '../data/skills';
import { SkillCategory } from '../types';

export default function Skills() {
  return (
    <section id="skills">
      <div className="wrap">
        <div className="eyebrow">Technical Capabilities</div>
        <h2 className="sectitle">Skills Taxonomy &amp; Core Stack</h2>
        <p className="secintro">
          Grouped by engineering domains — from autonomous AI agent orchestration and enterprise backend services to cloud infrastructure and identity governance.
        </p>

        <div className="skill-groups">
          {skills.map((group: SkillCategory) => (
            <div className="skillgroup" key={group.title}>
              <div className="skillgroup-head">
                <div className="gtitle">{group.title}</div>
                {group.description && <p className="gdesc">{group.description}</p>}
              </div>
              <div className="chiprow">
                {group.chips.map((chip) => (
                  <span className="chip" key={chip}>{chip}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
